import React, { FC }        from 'react';
import { useFormikContext } from 'formik';

import { TextField } from '../../../components/forms/formik';

interface Props {
	isLoading: boolean,
}

const defaultProps: Props = {
	isLoading: false,
}

const ProjectActivityUpdateAreaMeta: FC<Props> = ( props ) => {
	
	let { isLoading } = props,
	    form          = useFormikContext();
	
	return (
		
		<>
			{/*<TextField
				type='text'
				label={ 'Name' }
				name={ 'displayName' }
				placeholder='A descriptive label'
				loading={ isLoading }/>*/}
		</>
	);
};

ProjectActivityUpdateAreaMeta.defaultProps = defaultProps;

export { ProjectActivityUpdateAreaMeta }
